"use client";

import NumberFlow from "@number-flow/react";

/**
 * Tiny client leaf for the day counter — the ONLY client code in the
 * counter, so article routes importing the server DayCounter pay for
 * nothing beyond this chip. Renders "D14/62" style with a NumberFlow
 * numeral (animates on value change, static on first paint).
 */
export function DayCounterClient({ day, total }: { day: number; total: number }) {
  return (
    <span
      className="inline-flex items-baseline text-[13px] tabular-nums"
      aria-label={`Day ${day} of ${total}`}
    >
      <span aria-hidden="true" className="text-[var(--blog-muted,var(--color-text-mute))]">
        D
      </span>
      <NumberFlow
        value={day}
        aria-hidden="true"
        className="font-medium text-[var(--blog-accent,var(--color-indigo))]"
      />
      <span aria-hidden="true" className="text-[var(--blog-muted,var(--color-text-mute))]">
        /{total}
      </span>
    </span>
  );
}

export default DayCounterClient;
